/**
 * Auth API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NevisStatusResponse { 
    status: NevisStatusResponse.StatusEnum;
    chatToken?: string;
}
export namespace NevisStatusResponse {
    export const StatusEnum = {
        PENDING: 'pending',
        SUCCEEDED: 'succeeded',
        FAILED: 'failed'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


